import CreatorHistoryMediaPushPage from "./CreatorHistoryMediaPushPage";

export default CreatorHistoryMediaPushPage;
